import React, { useState } from 'react'
import { motion } from 'framer-motion'
import PropTypes from 'prop-types'
import useStore from '@/hooks/useStore'
import { find, get } from 'lodash'
import LoadingForm from './loadingForm'
import FormContactUs from './formContactUs'
import useGetValuesForm from './hook/useGetValuesForm'
import postGravityForm from '@/components/shared/utils/postGravityForm'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
// styles
import './styles.cus.scss'
import CompleteFormBaner from './completeFormBaner'

export default function ContactUs({ data }) {
  const idgravityform = get(data, ['settings_Forms', 'gravityform'], null)
  const { formValuesLoading, dataForm } = useGetValuesForm({ id: idgravityform })
  const [globalLoadingFrom, setGlobalLoadingFrom] = useState(false)
  const [isCompleteFrom, setIsCompleteFrom] = useState(false)
  const { acfOptions } = useStore()
  const siteOptions = acfOptions()
  const imgBrandFooter = get(siteOptions, ['footer_info', 'brand_section', 'brand_image'], null)
  const recaptchaSiteKey = get(siteOptions, ['recaptcha_site_key'], null)
  const subTitle = get(data, ['sub_title'], '')
  const title = get(data, ['title'], '')
  const fieldsForm = get(dataForm, ['fields'], [])
  const optionListSelect = fieldsForm.find((item) => item.adminLabel === 'interested')

  const onSubmitForm = async (valuesFrom) => {
    const requiredFields = ['fullName', 'email', 'interested', 'message']
    const newValuesFormReq = requiredFields.reduce((acc, field) => {
      const input = find(fieldsForm, ['adminLabel', field])
      if (input) {
        acc[`input_${input.id}`] = valuesFrom[field]
      }
      return acc
    }, {})
    if (Object.keys(newValuesFormReq).length === requiredFields.length) {
      const response = await postGravityForm({
        formId: dataForm.data.id,
        formData: newValuesFormReq,
      })
      setIsCompleteFrom(response)
      setGlobalLoadingFrom(false)
    }
  }

  return (
    <section className="mainSectionContactUs z-0">
      <LoadingForm isLoading={formValuesLoading || globalLoadingFrom} />
      <div className="content">
        <div className="content-container">
          <motion.div
            transition={{
              duration: 0.7,
              delay: 0.1,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            className="sectionText"
          >
            {imgBrandFooter && (
              <img
                className="imgContact"
                title={imgBrandFooter.filename}
                src={imgBrandFooter.url}
                alt={imgBrandFooter.alt}
              />
            )}
            <div>
              <span>{subTitle}</span>
              <h2>{title}</h2>
            </div>
          </motion.div>
          <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            {isCompleteFrom ? (
              <CompleteFormBaner />
            ) : (
              <FormContactUs
                onSubmitForm={onSubmitForm}
                setGlobalLoadingFrom={setGlobalLoadingFrom}
                optionList={optionListSelect?.choices.map((item) => ({
                  label: item.text.replace(/&amp;/g, '&'),
                  value: item.value,
                }))}
              />
            )}
          </GoogleReCaptchaProvider>
        </div>
      </div>
    </section>
  )
}

ContactUs.propTypes = {
  data: PropTypes.object,
}
